import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import imgParams from '../../utils/imageUtil';
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Box,
} from '@material-ui/core';
import CustomButton from '../common/customButton';
import { ellipsize } from '../../utils/textUtil';
import AdapterLink from '../common/adapterLink';
import { useTablet } from '../../hooks/utilHooks';
import { eventNames, eventProps } from '../../utils/eventConstants';
import analytics from '../../services/analyticsService';
import { ReactComponent as LocationIcon } from '../../img/location.svg';
import { stripDomain } from '../../utils/postUtil';
import profileService from '../../services/profileService';
import { useSnackBar } from '../../hooks/snackBarHooks';

const UserCard = ({ usersObj, userId }) => {
  const [isFollowed, setIsFollowed] = useState(usersObj?.isFollowed);
  const setToastMessage = useSnackBar('');
  const classes = useStyles();
  const isTablet = useTablet();
  let userDeepLink = '';
  if (usersObj?.userSlug) {
    userDeepLink = usersObj?.userSlug;
  } else if (usersObj?.userDeepLinkUrl) {
    userDeepLink = usersObj?.userDeepLinkUrl;
  } else {
    userDeepLink = '';
  }
  const deepLink = stripDomain(
    userDeepLink ? userDeepLink : usersObj?.mentorDeeplinkUrl
  );
  const location = usersObj?.location ? usersObj?.location : usersObj?.cityName;
  const entityId = usersObj?.entityId;

  async function clickToFollow() {
    const data = await profileService.followProfile(
      entityId,
      isFollowed,
      setToastMessage
    );
    if (data && data.status === 'SUCCESS') {
      setIsFollowed(!isFollowed);
      const eventName = isFollowed
        ? eventNames.profileFollowed
        : eventNames.profileUnFollowed;

      analytics.track(eventName, {
        [eventProps.followedUserId]: userId,
        [eventProps.name]: usersObj?.name,
        [eventProps.type]: usersObj.userType,
      });
    }
  }

  return (
    <React.Fragment>
      <Box px={2} py={6} className={classes.mainListItem}>
        <ListItem className={classes.listItem}>
          <Box
            to={deepLink || ''}
            component={AdapterLink}
            className="textDecorationHidden"
            display="flex"
          >
            <ListItemAvatar>
              <Avatar
                alt={usersObj?.name}
                src={imgParams(usersObj?.imageUrl, 80, 80)}
                className="defaultBorder"
              ></Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography
                  className={classes.name}
                  color="textPrimary"
                  variant="body2"
                >
                  {isTablet
                    ? ellipsize(usersObj?.name, 16)
                    : ellipsize(usersObj?.name, 50)}
                </Typography>
              }
              secondary={
                location && (
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    className={classes.text}
                  >
                    <LocationIcon className={classes.icon} />
                    {location}
                  </Typography>
                )
              }
            />
          </Box>
          <ListItemSecondaryAction className={classes.listItemAction}>
            <CustomButton
              variant="outlined"
              text={isFollowed ? 'Following' : 'Follow'}
              size="regular"
              className={
                isFollowed
                  ? `${classes.unfollowBtn} ${classes.followBtn}`
                  : classes.followBtn
              }
              onClick={() => clickToFollow()}
            ></CustomButton>
          </ListItemSecondaryAction>
        </ListItem>
      </Box>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  mainListItem: {
    background: 'white',
    listStyle: 'none',
  },
  listItem: {
    padding: theme.spacing(0),
  },
  listItemAction: {
    right: theme.spacing(0),
  },
  followBtn: {
    width: '80px',
    fontSize: '14px',
    padding: theme.spacing(0.2),
    right: theme.spacing(0),
  },
  unfollowBtn: {
    border: '1px solid #000',
    color: theme.palette.text.primary,
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  name: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingRight: theme.spacing(10),
    textDecoration: 'none',
  },
}));

export default UserCard;
